import { SettingsPageGetDueDiligenceFunnelQuery } from '@/__generated__/graphql';
import { RedStarIcon } from '@/assets/icons/info-icons/redStar';
import { DragAndDropBigIcon } from '@/assets/static/icons/drag-and-drop-icon';
import ActionDropdown from '@/components/basicComponents/actionDropdown';
import { useResponsive } from '@/hooks/use-responsive';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { ActionWrap, DragAndDropIconWrap, InfoRowCell, RowWrapper } from './sectionFields';

interface TierChecklistItemsProps {
  checklistItems: SettingsPageGetDueDiligenceFunnelQuery['getDueDiligenceFunnel']['tiers'][number]['checklistItems'];
  isLimitedEdits: boolean;
  tierId: string;
  isDragDisabled: boolean;
  canDragging: { action: boolean; id: string };
  openModalWindow: (
    type: string,
    id: string,
    row: SettingsPageGetDueDiligenceFunnelQuery['getDueDiligenceFunnel']['tiers'][number]['checklistItems'][number],
    rowType: string
  ) => void;
}

export const TierChecklistItems = ({
  checklistItems,
  isLimitedEdits,
  tierId,
  isDragDisabled,
  canDragging,
  openModalWindow
}: TierChecklistItemsProps) => {
  const { isMobile } = useResponsive();

  return (
    <Droppable droppableId={tierId} type="CHECKLIST">
      {(provided) => (
        <div ref={provided.innerRef} {...provided.droppableProps}>
          {checklistItems.map((item, index) => (
            <Draggable key={item.id} draggableId={item.id} index={index} isDragDisabled={isLimitedEdits || isDragDisabled}>
              {(provided, snapshot) => (
                <div {...provided.dragHandleProps} {...provided.draggableProps} ref={provided.innerRef}>
                  <RowWrapper
                    disabled={false}
                    isDragging={snapshot.isDragging}
                    isMobile={isMobile}
                    loading={!canDragging.action && canDragging.id === item.id ? 1 : 0}
                  >
                    <InfoRowCell>
                      {!isLimitedEdits && (
                        <DragAndDropIconWrap id="dragIcon">
                          <DragAndDropBigIcon style={{ position: 'relative', top: '3px' }} />
                        </DragAndDropIconWrap>
                      )}
                      {item?.required ? <RedStarIcon width={10} height={10} /> : <NoRequired />}
                      {item?.name}
                    </InfoRowCell>
                    <ActionWrap isMobile={isMobile}>
                      <ActionDropdown
                        size="md"
                        options={
                          isLimitedEdits
                            ? [
                                {
                                  name: 'Edit',
                                  onClick: () => openModalWindow('add-checklist', item.id, item, 'checklist')
                                }
                              ]
                            : [
                                {
                                  name: 'Edit',
                                  onClick: () => openModalWindow('add-checklist', item.id, item, 'checklist')
                                },
                                {
                                  name: 'Delete',
                                  onClick: () => openModalWindow('delete-checklist', item.id, item, 'checklist')
                                }
                              ]
                        }
                      />
                    </ActionWrap>
                  </RowWrapper>
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

const NoRequired = styled.div`
  width: 10px;
`;
